module.exports = __webpack_public_path__ + "img/klap.f601a71.png";